import { render, staticRenderFns } from "./TableReportViewer.vue?vue&type=template&id=dfd05abe&scoped=true"
import script from "./TableReportViewer.vue?vue&type=script&lang=js"
export * from "./TableReportViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd05abe",
  null
  
)

export default component.exports